/* Branded Best House: the gift finder (sections/bb-gift-finder.liquid).
   Five answers in, three real pieces from the catalog out. Rules, not a model: the same answers always give the
   same picks. The picking is one pure function (pick), tested in node; the page part below only draws it.
   Pieces, prices and minimums come from the store through Liquid, so a reprice or a new pack moves the picks. */
(function (root) {
  'use strict';

  var MOMENTS = ['hires', 'clients', 'events', 'recog', 'sales'];
  var GROUP_SIZE = { lt100: 50, '100': 100, '250': 250, '1000': 1000 };

  // a piece's price band from its lowest price a piece (cents) and the band edges (dollars, ascending)
  function bandOf(perPieceCents, edges) {
    var d = perPieceCents / 100;
    for (var i = 0; i < edges.length; i++) if (d < edges[i]) return i + 1;
    return edges.length + 1;
  }

  // the pack this group would buy, [pieces, cents a piece]: the largest pack that fits the group, else the smallest
  // pack; null when the piece has no Pack option
  function packFor(c, size) {
    var packs = (c.packs || []).slice().sort(function (a, b) { return a[0] - b[0]; });
    if (!packs.length) return null;
    var at = packs[0];
    packs.forEach(function (pk) { if (pk[0] <= size) at = pk; });
    return at;
  }
  // the price a piece at that pack
  function perFor(c, size) {
    var at = packFor(c, size);
    return at ? at[1] : (c.perPiece || 0);
  }
  // " at 100": the pack a price is for, so "$5 a piece" never sits beside a different pack size unexplained
  function atText(c, size) {
    var at = packFor(c, size);
    return at ? ' at ' + fmtN(at[0]) : '';
  }
  function fmtN(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  // state: { moment, people, budget (1..n), when, who }
  // catalog: [{ id, title, moments[], who[], packs [[pieces, cents a piece]], minPack, always[], teamOnly }],
  // in the order Nick set
  function pick(state, catalog, edges) {
    catalog = catalog || [];
    edges = edges || [15, 40, 80];
    var maxBand = edges.length + 1;
    var size = GROUP_SIZE[state.people] || 100;
    var target = Math.min(maxBand, (Number(state.budget) || 1) + (state.who === 'vip' ? 1 : 0));
    // a piece made for a company's own people (the metal card) is never offered as a client gift
    var allowed = catalog.filter(function (c) {
      return !(c.teamOnly && (state.who === 'clients' || state.moment === 'clients'));
    });
    var has = function (list, v) { return (list || []).indexOf(v) >= 0; };
    var score = function (c) {
      var b = bandOf(perFor(c, size), edges);
      return Math.abs(b - target) * 10 + (c.minPack > size ? 15 : 0) + (has(c.who, state.who) ? 0 : 3);
    };
    var byScore = function (list) {
      return list.map(function (c, i) { return { c: c, s: score(c), i: i }; })
        .sort(function (a, b) { return a.s - b.s || a.i - b.i; })
        .map(function (x) { return x.c; });
    };
    var forMoment = allowed.filter(function (c) { return has(c.moments, state.moment); });
    var ranked = byScore(forMoment);
    // too few pieces for this moment: fill from the rest of the catalog, still closest to budget first
    if (ranked.length < 3) {
      ranked = ranked.concat(byScore(allowed.filter(function (c) { return ranked.indexOf(c) < 0; })));
    }
    // a piece Nick marked as the answer for this moment always makes the three, first
    var lead = allowed.filter(function (c) { return has(c.always, state.moment); });
    var three = lead.concat(ranked.filter(function (c) { return lead.indexOf(c) < 0; })).slice(0, 3);

    var notes = [];
    if (state.when === 'month') notes.push({ key: 'timing' });
    if (state.when === 'monthly') notes.push({ key: 'monthly' });
    if (state.people === 'lt100') notes.push({ key: 'small' });
    else if (three.some(function (c) { return c.minPack > size; })) notes.push({ key: 'minimum' });
    return { picks: three, notes: notes, target: target, size: size };
  }

  // the plan as plain text, for the email to our team
  function planText(state, result, labels) {
    var L = function (q, v) { return (labels[q] && labels[q][v]) || v; };
    var lines = [
      'Gift plan from the gift finder',
      'For: ' + L('moment', state.moment),
      'People: ' + L('people', state.people),
      'Budget a person: ' + L('budget', state.budget),
      'When: ' + L('when', state.when),
      'Who gets it: ' + L('who', state.who),
      '',
      'Picks:'
    ];
    result.picks.forEach(function (c, i) {
      lines.push((i + 1) + '. ' + c.title + ' (' + money(perFor(c, result.size)) + ' a piece' + atText(c, result.size) + (c.minText ? ', packs from ' + c.minText : '') + ') ' + c.url);
    });
    return lines.join('\n');
  }

  function money(cents) { return '$' + (cents % 100 ? (cents / 100).toFixed(2) : String(cents / 100)); }

  var api = { pick: pick, bandOf: bandOf, perFor: perFor, packFor: packFor, atText: atText, planText: planText, money: money, MOMENTS: MOMENTS };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  root.BBGiftFinder = api;

  // ---------- the page ----------
  function init(el) {
    var data;
    try { data = JSON.parse(el.querySelector('[data-gf-data]').textContent); } catch (e) { return; }
    var state = data.start;
    var picksEl = el.querySelector('[data-gf-picks]');
    var notesEl = el.querySelector('[data-gf-notes]');
    var planEl = el.querySelector('[data-gf-plan]');
    var cards = {};
    // one card per piece, built once from Liquid's markup, so Nick's logo tool sees the same photo each time
    el.querySelectorAll('[data-gf-piece]').forEach(function (n) { cards[n.getAttribute('data-gf-piece')] = n; });

    function render() {
      el.querySelectorAll('[data-gf-q]').forEach(function (group) {
        var q = group.getAttribute('data-gf-q');
        group.querySelectorAll('button[data-v]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === String(state[q])));
        });
      });
      var r = pick(state, data.catalog, data.edges);
      // move the chosen cards into the picks row, in order; the rest wait in the hidden store
      var store = el.querySelector('[data-gf-store]');
      Object.keys(cards).forEach(function (id) { if (cards[id].parentNode !== store) store.appendChild(cards[id]); });
      r.picks.forEach(function (c) {
        var card = cards[c.id];
        if (!card) return;
        var price = card.querySelector('[data-gf-price]');
        if (price) price.textContent = money(perFor(c, r.size));
        var at = card.querySelector('[data-gf-at]');
        if (at) at.textContent = atText(c, r.size);
        var min = card.querySelector('[data-gf-min]');
        if (min) min.textContent = c.minText;
        var minWrap = card.querySelector('[data-gf-min-wrap]');
        if (minWrap) minWrap.hidden = !c.minText;
        picksEl.appendChild(card);
      });
      notesEl.innerHTML = '';
      r.notes.forEach(function (n) {
        var t = data.notes[n.key];
        if (!t) return;
        var p = document.createElement('p');
        p.className = 'bbgf__note';
        p.textContent = t;
        notesEl.appendChild(p);
      });
      if (planEl) planEl.value = planText(state, r, data.labels);
    }

    el.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-v]');
      if (!b || !el.contains(b)) return;
      var q = b.closest('[data-gf-q]').getAttribute('data-gf-q');
      var v = b.getAttribute('data-v');
      state[q] = q === 'budget' ? Number(v) : v;
      render();
    });
    render();
    el.classList.add('is-live');
  }

  function start() { document.querySelectorAll('[data-gift-finder]').forEach(init); }
  // the theme editor re-renders the section after every change: start it again
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-gift-finder]').forEach(init);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})(this);
